export default class KeysNavigation {
	constructor() {
		this.init();
	}

	init() {
		document.addEventListener( 'keydown', ( e ) => {
			switch ( e.keyCode ) {
				case 37:
					var element = document.getElementById("linkPrev");
					if( element ) {
						element.click();
					}
					break;
				case 39:
					var element = document.getElementById("linkNext");
					if (element) {
						element.click();
					}
					break;
			}
		} );
	}
}
